import { useMutation } from '@apollo/client';
import { t } from 'i18next';
import React, { useState } from 'react'
import { ForgetPassword } from '../../graphql';
import SuccessAlert from '../../components/Alerts/SuccessAlert';
import FailAlert from '../../components/Alerts/FailAlert';
import { FaLock } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const ForgotPassword = () => {

  const [email, setEmail] = useState("");

  const [success, setSuccess] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [fail, setFail] = useState(false);
  const [failMsg, setFailMsg] = useState("");

  const [forgetPassword, { loading }] = useMutation(ForgetPassword, {
    onError: () => {
      setFail(true);
      setFailMsg(t('emailIncorrect'));
      return
    },
    onCompleted: () => {
      setSuccess(true);
      setSuccessMsg(t("Link sended successfully"));
    }
  });

  const sendLink = async () => {
    if (email === "") {
      setFailMsg(t('emailEmpty'));
      setFail(true);
      return
    }

    await forgetPassword({
      variables: {
        email: email
      }
    })
  }

  return (
    <div className='flex items-center justify-center w-full min-h-screen'>
      {success && <SuccessAlert success={success} setSuccess={setSuccess} successMsg={successMsg} />}

      {fail && <FailAlert fail={fail} setFail={setFail} failMsg={failMsg} />}

      <div className='relative w-5/6 p-2 rounded-md sm:w-3/6 md:w-2/6'>
        {loading &&
          <div className='absolute top-0 left-0 z-30 flex items-center justify-center w-full h-full py-10 overflow-hidden bg-white/70'>
            <svg aria-hidden="true" className="w-8 h-8 mr-2 text-gray-200 animate-spin fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
              <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
            </svg>
          </div>
        }

        <div className='p-2'>
          <div className='flex justify-center pb-8'>
            <div className='flex flex-col items-center'>
              <FaLock size={48} className='text-primary' />
              <h3 className='pt-3 text-2xl font-semibold'>{t("Password Recovery")}</h3>
            </div>
          </div>

          <div>
            <p className='pb-3 text-gray-800'>{t('Enter your Account email address and we will send you a reset link')}</p>
            <span>{t('email')}</span>
            <input type="text" value={email} onChange={(e) => setEmail(e.target.value)} className='w-full px-2 py-2 my-2 border rounded outline-none bg-gray-50' placeholder={t('email')} />
            <button onClick={() => sendLink()} className='w-full px-4 py-2 mt-3 font-semibold text-white duration-300 rounded-md bg-primary hover:bg-primaryHover'>{t('Send Link')}</button>
          </div>
          <div className='flex justify-center pt-1'>
            <Link to="/" className='text-sm font-semibold text-primary'>{t('Return to login')}</Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ForgotPassword